import React from 'react'
import { GROUP, BRAND } from '../../CompanyInfo';

const OurVision = () => {
    return (
        <div className="container" style={{ minHeight: 400 }}>
            <div className="bg-white p-4 m-5">
                <h3 className='text-center mb-3' style={{ color: BRAND.purple, fontWeight: 700 }}>
                    Our Vision
                </h3>
                <p style={{ fontSize: 18 }}>
                    To be the most dependable pharmaceutical and veterinary distribution partner in
                    coastal and central Karnataka &mdash; the name a pharmacist, doctor or veterinarian
                    reaches for first when a medicine has to be there today.
                </p>
                <p>
                    {GROUP.name} has served the trade {GROUP.since.toLowerCase()}. We intend to keep
                    growing that trust through honest dealing, correct stock, transparent pricing and
                    full regulatory compliance at every step of the chain.
                </p>
            </div>
        </div>
    )
}

export default OurVision
